function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import classNames from 'classnames';
import { capitalize, isObject } from 'lodash';
import _ from 'lodash/fp';
import T from 'prop-types';
import React, { useContext, useMemo, useRef } from 'react';
import { Modal } from 'react-bootstrap';
import { BUY_NOW_DATA_TYPES, PRODUCT_TYPE } from '../../../../constants/product';
import text from '../../../../text';
import { IconWrapper } from '../../../RightMenu/Product';
import SimpleDataRow from '../../../RightMenu/SimpleDataRow';
import { MapViewContext } from '../../../mapView/mapViewContext';
import ProductTooltip from '../../../mapView/productTooltip/ProductTooltip';
import DataTable from '../../../table/dataTable/DataTable';
import ShapeMenuModal from '../../ShapeMenuModal';
import useProduct from '../hooks/useProduct';
import CloseButton from './CloseButton';
import WithLoader from './WithLoader';
var Body = function(param) {
    var isHeaderShown = param.isHeaderShown;
    var _useContext = useContext(MapViewContext), state = _useContext.state, actions = _useContext.actions;
    var shapeMenuModalRef = state.shapeMenuModalRef, openedShapeMenu = state.openedShapeMenu;
    var rowRefs = useRef([]);
    var _useProduct = useProduct(), charges = _useProduct.charges, age = _useProduct.age, productTotalArea = _useProduct.totalArea, shapesUnionArea = _useProduct.shapesUnionArea, shapes = _useProduct.shapes, price = _useProduct.price, isEssentialUser = _useProduct.isEssentialUser, isFreeOrTrial = _useProduct.isFreeOrTrial, hasMemberDiscount = _useProduct.hasMemberDiscount, memberDiscount = _useProduct.memberDiscount, priceWithSalesHelp = _useProduct.priceWithSalesHelp, productType = _useProduct.productType, isReadOnly = _useProduct.isReadOnly, isStaff = _useProduct.isStaff;
    var isFreeUser = !isEssentialUser;
    var priceSalesHelpTemplate = isObject(priceWithSalesHelp) && priceWithSalesHelp.value > 0 && /*#__PURE__*/ React.createElement("div", {
        className: classNames('discount', {
            'mt-1': isEssentialUser,
            'mb-1': isFreeUser
        })
    }, /*#__PURE__*/ React.createElement("span", {
        className: classNames({
            'text-strikethrough': isFreeUser
        })
    }, isFreeUser ? text('salesHelp', {
        amount: priceWithSalesHelp.total
    }) : capitalize(text('buyNow'))), ', ', /*#__PURE__*/ React.createElement("span", {
        className: classNames({
            'text-strikethrough': isEssentialUser
        })
    }, isFreeUser ? text('savingAmount', {
        saving: priceWithSalesHelp.saved
    }) : "or ".concat(text('salesHelp', {
        amount: priceWithSalesHelp.total
    }))));
    var shapeMenuIsOpened = useMemo(function() {
        return openedShapeMenu.data && shapeMenuModalRef;
    }, [
        openedShapeMenu,
        shapeMenuModalRef
    ]);
    var handleSetOpenedShapeMenu = function(data, index) {
        if (rowRefs.current[index]) {
            actions.setOpenedShapeMenu(function(prev) {
                return _object_spread_props(_object_spread({}, prev), {
                    data: _object_spread_props(_object_spread({}, data), {
                        index: index
                    }),
                    prevCategoryName: data.category_name
                });
            });
            shapeMenuModalRef.current = rowRefs.current[index];
        }
    };
    var _openedShapeMenu_data_name;
    return /*#__PURE__*/ React.createElement(Modal.Body, {
        className: classNames('pt-0 px-0', {
            'pb-4': !state.isProductModalExpanded
        })
    }, /*#__PURE__*/ React.createElement("div", {
        className: classNames('d-flex flex-row product align-items-center p-3', productType)
    }, /*#__PURE__*/ React.createElement(IconWrapper, {
        icon: productType,
        className: "mr-1"
    }), /*#__PURE__*/ React.createElement("div", {
        className: "text-truncate",
        style: {
            width: '100%'
        }
    }, text("".concat(productType, "3D"))), /*#__PURE__*/ React.createElement("div", {
        className: "d-flex flex-row"
    }, /*#__PURE__*/ React.createElement(ProductTooltip, {
        productType: productType,
        placement: "top"
    }), !isHeaderShown && /*#__PURE__*/ React.createElement(CloseButton, null))), /*#__PURE__*/ React.createElement("div", {
        className: "px-3 pt-3 overflow-auto",
        style: {
            maxHeight: '60vh'
        }
    }, /*#__PURE__*/ React.createElement("div", {
        className: classNames('d-flex flex-row', {
            'pb-1': isObject(priceWithSalesHelp)
        })
    }, /*#__PURE__*/ React.createElement(WithLoader, {
        hasCharges: !!charges
    }, /*#__PURE__*/ React.createElement("div", {
        className: classNames('price')
    }, price.formatted)), /*#__PURE__*/ React.createElement("div", {
        className: classNames('grey-1 font-weight-bold font-12 d-flex flex-row flex-fill align-items-center justify-content-end')
    }, text('productAreaTotal', {
        delimiter: ':',
        productTotalArea: /*#__PURE__*/ React.createElement(WithLoader, {
            key: productType,
            hasCharges: !!charges,
            showLoaderText: false,
            className: "ml-3",
            fullWidth: false
        }, /*#__PURE__*/ React.createElement("span", {
            key: new Date().getTime(),
            className: "".concat(productType, "-product-area mb-0 ml-1 px-1 font-14")
        }, productTotalArea.formatted))
    }))), /*#__PURE__*/ React.createElement("hr", {
        className: "mx-0 emphasis"
    }), isFreeUser ? priceSalesHelpTemplate : null, /*#__PURE__*/ React.createElement(WithLoader, {
        hasCharges: !!charges
    }, isFreeOrTrial && hasMemberDiscount || isStaff ? /*#__PURE__*/ React.createElement("div", {
        className: classNames('discount', {
            'font-pink': !isEssentialUser || isStaff
        })
    }, memberDiscount, ' ') : null), isEssentialUser ? priceSalesHelpTemplate : null, state.isProductModalExpanded ? /*#__PURE__*/ React.createElement(React.Fragment, null, hasMemberDiscount ? /*#__PURE__*/ React.createElement("hr", {
        className: "mx-0"
    }) : null, /*#__PURE__*/ React.createElement(DataTable, {
        className: "product-selected-shapes mb-0"
    }, /*#__PURE__*/ React.createElement("tbody", null, /*#__PURE__*/ React.createElement("tr", null, /*#__PURE__*/ React.createElement("td", {
        className: "pointCloudColumn"
    }), /*#__PURE__*/ React.createElement("td", {
        colSpan: 3,
        className: "areaColumn product-area text-left pl-3"
    }, /*#__PURE__*/ React.createElement("span", {
        className: "border-bottom"
    }, "".concat(text('productArea'), "s")))), shapes === null || shapes === void 0 ? void 0 : shapes.map(function(selection, index) {
        var coverage = _.find([
            'selection_id',
            selection.id
        ])(state.coveragePerProduct[productType]);
        return /*#__PURE__*/ React.createElement(SimpleDataRow, {
            key: selection.id,
            data: selection,
            coverage: coverage,
            index: index,
            isReadOnly: isReadOnly,
            useMeatballDropdown: false,
            showClearWhenShapeSelected: false,
            ref: function(el) {
                if (openedShapeMenu.data && openedShapeMenu.data.id === selection.id) {
                    // if ShapeMenuModal is already opened and type is changed
                    // set the ref to the new element created
                    // and stay opened based on closeDropdownOnSelect value
                    shapeMenuModalRef.current = el;
                }
                rowRefs.current[index] = el;
            },
            handleSetOpenedShapeMenu: handleSetOpenedShapeMenu
        });
    }))), shapesUnionArea.value > 0 && /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement("div", {
        className: "grey-3 font-12 mt-3"
    }, text('shapesUnion', {
        union: ![
            PRODUCT_TYPE.INTERIOR,
            PRODUCT_TYPE.BIM_INTERIOR,
            PRODUCT_TYPE.TWOD_PLAN_INTERIOR
        ].includes(productType) ? '(union) ' : '',
        shapesUnionArea: shapesUnionArea.formatted
    })), /*#__PURE__*/ React.createElement("hr", {
        className: "mx-0"
    })), /*#__PURE__*/ React.createElement("div", {
        className: classNames('d-flex flex-column', {
            'mt-3': shapesUnionArea.value <= 0
        })
    }, /*#__PURE__*/ React.createElement("div", {
        className: "grey-3 font-12"
    }, age), /*#__PURE__*/ React.createElement("div", {
        className: "grey-2",
        style: {
            fontSize: 12
        }
    }, text('turnAroundTime', {
        eta: BUY_NOW_DATA_TYPES.includes(productType) ? '2 hours' : '2 weeks'
    })))) : null), shapeMenuIsOpened ? /*#__PURE__*/ React.createElement(ShapeMenuModal, {
        ref: shapeMenuModalRef,
        shapeData: openedShapeMenu.data,
        shapeName: (_openedShapeMenu_data_name = openedShapeMenu.data.name) !== null && _openedShapeMenu_data_name !== void 0 ? _openedShapeMenu_data_name : "Shape ".concat(openedShapeMenu.data.index + 1)
    }) : null);
};
Body.propTypes = {
    isHeaderShown: T.bool
};
export default Body;
